export const dmsUrl = item => {
    if (item.url && item.url.search('dms-test') > 0) {
        return item.url;
    }

    return `https://dms-cf-0${Math.floor(Math.random() * (10 - 1) + 1)}.dimu.org/image/${item.dms_id}`;
};
